import { ReturnItem } from 'services/api/refund';
import { useTranslate } from '@tolgee/react';
import { DetailCard } from '../DetailCard';
import { OrderProduct } from '../OrderCard/OrderProduct';
import { getOrderProductPropsFromReturnItem } from 'components/LightConversation/utils/order';
import toLowerCase from 'utils/toLowerCase';
import { formatNumber } from 'utils/numberFormat';
import { useMemo } from 'react';

interface OrderReturnItemsProps {
  platform: General.PlatformUpperCase;
  refundAmount: number;
  unit: string;
  returnItems: ReturnItem[];
}

export const OrderReturnItems = (props: OrderReturnItemsProps) => {
  const { platform, unit, returnItems, refundAmount } = props;
  const { t } = useTranslate();
  const items = useMemo(() => {
    return returnItems.reduce<
      {
        itemId: string;
        itemName: string;
        itemPic: string;
        itemUrl: string;
        sku: string;
        sellerSku: string;
        quantity: number;
        discountedPrice?: number;
        isPreOrder: boolean;
      }[]
    >((res, cur) => {
      if (!cur.returnSubLineItems?.length) {
        res.push(getOrderProductPropsFromReturnItem(cur));
      } else {
        res.push(
          ...cur.returnSubLineItems.map(({ itemId, itemImage, itemName, skuId, sellerSku }) => {
            return {
              itemId,
              itemName,
              itemPic: itemImage[0],
              itemUrl: '',
              sku: skuId,
              sellerSku,
              quantity: 1,
              discountedPrice: undefined,
              isPreOrder: false,
            };
          }),
        );
      }
      return res;
    }, []);
  }, [returnItems]);
  return (
    <DetailCard
      title={t('x个商品', { count: items.length })}
      rightExtra={
        <div className="text-[16px] text-[#232426] font-medium">
          {t('ViewRefund.退款总金额')}:{unit} {formatNumber(refundAmount, '0,0.00')}
        </div>
      }
    >
      <div className="flex flex-col gap-3 bg-[#F7F9FA] rounded p-3">
        {items.map((item) => {
          return (
            <div key={item.itemId}>
              <OrderProduct {...item} platform={toLowerCase(platform)} unit={unit} simple={false} />
            </div>
          );
        })}
      </div>
    </DetailCard>
  );
};
